import { fetchBasicUrlGetJson, fetchBasicJsonPostJson, fetchBasicUrlPostJson } from '@/script/common';

export default {
    getData: (page, pageSize, filter) => fetchBasicJsonPostJson('/Diagnosis/GetData', { data: { page, pageSize, ...filter } }),
    getTotalPrices: (historyCode, diagnosisNumber) => fetchBasicUrlGetJson('/Diagnosis/GetTotalPrices', { data: { historyCode, diagnosisNumber } }),
    get: data => fetchBasicUrlGetJson('/Diagnosis/Get', { data: data }),
    addOrEdit: data => {
        const formatedData = {
            HistoryCode: data.historyCode,
            DateTimeFrom: data.DateTimeFrom,
            DateTimeTill: data.DateTimeTill,
            Status: data.Status,
            DepartmentCode: data.DepartmentCode,
            DZIR: data.DZIR,
            PlanType: data.PlanType,
            HepatitisC: data.HepatitisC,
            StandardPrice: data.StandardPrice,
            PricePercent: data.PricePercent,
            Year: data.Year,
            SalaryYear: data.SalaryYear,
            SalaryMonth: data.SalaryMonth,
            ProvisionalDiagnosis: data.ProvisionalDiagnosis,
            Base: data.Base,
            Kat: data.Kat,
            Number: data.Number,
            MessageCode: data.MessageCode,
            NosologyCode: data.NosologyCode,
            DoctorCode: data.DoctorCode,
            Out: data.Out,
            NurseCode: data.NurseCode,
            OtherCode: data.OtherCode,
            SenderDoctor: data.SenderDoctor,
            Amount: data.Amount,
            Price: data.Price
        }

        data.SelectedChekBoxes.forEach(box => {
            formatedData[box] = 'on'
        });

        return fetchBasicUrlPostJson('/Diagnosis/Save', { data: formatedData })
    }
};
